// const BASE_URL="https://cdn.lk-ft.ru/"
export const BASE_URL = process.env.REACT_APP_STRAPI_URL || "https://cdn.lk-ft.daark.net";
export const SCORE_URL = process.env.REACT_APP_SCORE_URL || "https://xlsx.lk-ft.daark.net/footskill/api/v1/";
export const FOOTSKILL_TOOLS_URL =
  process.env.REACT_APP_FOOTSKILL_TOOLS_URL || `${SCORE_URL}footskill/`;
